var map = {
	"./errorEmoji.svg": "./components/icons/errorEmoji.svg",
	"./heart.svg": "./components/icons/heart.svg",
	"./iconClose.svg": "./components/icons/iconClose.svg",
	"./iconDownCaret.svg": "./components/icons/iconDownCaret.svg",
	"./leftArrow.svg": "./components/icons/leftArrow.svg",
	"./notification.svg": "./components/icons/notification.svg",
	"./search.svg": "./components/icons/search.svg",
	"./snowflake.svg": "./components/icons/snowflake.svg",
	"./tick.svg": "./components/icons/tick.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components/icons sync recursive ^\\.\\/.*\\.svg$";